import { Billing } from './billing/Billing.js';
import { Clients } from './clients/Clients.js';
import { ComOrderRepository } from './orders/ComOrderRepository.js';
import { Shipments } from './shipments/Shipments.js';
import { Users } from './users/Users.js';
import { Places } from './places/Places.js';

class Com {
  /** @deprecated import ComOrderRepository instead */

  constructor(apiClient) {
    this.apiClient = apiClient;
    this.billing = new Billing(apiClient);
    this.clients = new Clients(apiClient);
    this.orders = new ComOrderRepository(apiClient);
    this.shipments = new Shipments(apiClient);
    this.users = new Users(apiClient);
    this.places = new Places(apiClient);
  }
}

export { Com };
//# sourceMappingURL=Com.js.map
